/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.QuizQuestionType_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.QuizQuestionType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum QuizQuestionType_ {
   /// <summary>
   ///   Standard (Standard)
   /// </summary>
   Standard = 1,
   /// <summary>
   ///   Evidence Based Selective Response (EBSR)
   /// </summary>
   EBSR = 2,
   /// <summary>
   ///   Reading Comprehension (Reading)
   /// </summary>
   ReadingComprehension = 3
}

export const QuizQuestionTypes: QuizQuestionType[] = [
   {
      code: QuizQuestionType_.Standard,
      literal: 'Standard',
      description: 'Standard',
      shortDescription: 'Standard',
      listPriority: 1,

      maxQuestions: 1,

      typeName: "QuizQuestionType"
   },
   {
      code: QuizQuestionType_.EBSR,
      literal: 'EBSR',
      description: 'Evidence Based Selective Response',
      shortDescription: 'EBSR',
      listPriority: 2,

      maxQuestions: 2,

      typeName: "QuizQuestionType"
   },
   {
      code: QuizQuestionType_.ReadingComprehension,
      literal: 'ReadingComprehension',
      description: 'Reading Comprehension',
      shortDescription: 'Reading',
      listPriority: 5,

      maxQuestions: 3,

      typeName: "QuizQuestionType"
   }
]

export class QuizQuestionType implements IDomainModel {
   code: QuizQuestionType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   maxQuestions: number

   typeName: string

   static toDomainModel(code: QuizQuestionType_): QuizQuestionType {
      return QuizQuestionTypes.find(d => d.code === code)
   }
}
